"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.criticalErrorHandlersStorage = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// You need to call `setErrorHandlers` before using api
var CriticalErrorHandlersStorage = /*#__PURE__*/function () {
  function CriticalErrorHandlersStorage() {
    _classCallCheck(this, CriticalErrorHandlersStorage);
  }
  return _createClass(CriticalErrorHandlersStorage, [{
    key: "setErrorHandlers",
    value:
    /**
     * errorHandlers is function like:
     * function(redirectFunction) {
     *   return {
     *     [API_BAD_REQUEST_ERROR]: () => redirectFunction('/'),
     *     [API_FORBIDDEN_ERROR]: () => redirectFunction('/'),
     *     [API_NOT_FOUND_ERROR]: () => redirectFunction('/'),
     *     [API_UNKNOWN_ERROR]: () => redirectFunction('/'),
     *   };
     * }
     *
     * @param errorHandlers
     */
    function setErrorHandlers(errorHandlers) {
      this.errorHandlers = errorHandlers;
    }
  }, {
    key: "getErrorHandlers",
    value: function getErrorHandlers() {
      if (typeof this.errorHandlers !== 'function') {
        throw new Error('Unable to get errorHandlers. You should use `setErrorHandler` before using api.');
      }
      return this.errorHandlers;
    }
  }, {
    key: "getCriticalErrorCodes",
    value: function getCriticalErrorCodes() {
      if (typeof this.errorHandlers !== 'function') {
        throw new Error('Unable to get errors codes. You should use `setErrorHandler` before using api.');
      }
      return Object.keys(this.errorHandlers());
    }
  }]);
}();
var _default = exports["default"] = CriticalErrorHandlersStorage; // it's singleton for the whole application
var criticalErrorHandlersStorage = exports.criticalErrorHandlersStorage = new CriticalErrorHandlersStorage();